<select (change)="selectEvent()" [(ngModel)]="selectOption" class="form-control event-list">
  <ng-container *ngIf="events$ | async as events">
    <option *ngFor="let event of events" [value]="event.GameNumber">
      {{event.Date | date:'MMM d, y, h:mm'}}{{event.Date | date:'a' | lowercase}}  {{event.Teams}}
    </option>
  </ng-container>
</select>

